import React from 'react';

type Props = {
	height: number;
	className?: string;
};

export const DottedLine: React.FC<Props> = ({ height, className = "" }) => {
	return (
		<div 
			className={`w-[2px] ${className}`}
			style={{ 
				height: `${height}px`,
				borderTop: 'none',
				borderRight: 'none',
				borderBottom: 'none',
				borderLeft: '1px dashed #51B447',
				borderRightWidth: 0,
				borderRightColor: "transparent"
			}}
		/>
	);
};

export default DottedLine;
